module.exports = __webpack_public_path__ + "f5f0fa9deadd75ac1a9c2e28dbaa4ed2.svg";